
import React from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Main from './component/main/Main';
import Topics from './component/topics/Topics';
import './App.css';
import ErrorPage from './component/ErrorPage';
import QuizeDetails from './component/quizDetails/QuizeDetails';
import Recharts from './component/rechart/Recharts';
import Blog from './component/blog/Blog';


function App() {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <Main></Main>,
      errorElement: <ErrorPage></ErrorPage>,
      children: [
        {
          path: '/',
          loader: () =>fetch('https://openapi.programming-hero.com/api/quiz'),
          element: <Topics></Topics>,
          errorElement: <ErrorPage></ErrorPage>
        },
        {
          path: 'topics',
          loader: () =>fetch('https://openapi.programming-hero.com/api/quiz'),
          element:<Topics></Topics>,
          errorElement: <ErrorPage></ErrorPage>
        },
       
        {
          path: 'statistis',
          loader: () =>fetch('https://openapi.programming-hero.com/api/quiz'),
          element:<Recharts></Recharts>,
          errorElement: <ErrorPage></ErrorPage>
        },
       
        {
          path:'blog',
          loader: () =>fetch('https://openapi.programming-hero.com/api/quiz'),
          element:<Blog></Blog>,
          errorElement: <ErrorPage></ErrorPage>
        },
       
      
        
      
        {
          path:'quizitem/:quizitemid', 
          loader: async ({params}) => {
            return fetch(`https://openapi.programming-hero.com/api/quiz/${params.quizitemid}`)
          },
          element: <QuizeDetails></QuizeDetails>,
          errorElement: <ErrorPage></ErrorPage>
        },
       ]

    }
  ])

  return (

    <div>
      <RouterProvider router={router}></RouterProvider>
    </div>
  );
}

export default App;
